import React, { useEffect, useState } from 'react';
import {
  Pagination,
  Table,
  Popconfirm,
  Row,
  Input,
  Col,
  Typography,
  Divider, message
} from 'antd';
import Moment from 'react-moment';
import seguridadProvider from '../../../../services/seguridadProvider';

const Search = Input.Search;
const { Text } = Typography;

const pageSize = 5;
const PaginacionPersonalizada = ({ total, onChange, current }) => {
  return (
    <Pagination onChange={onChange} simple={true} total={total} current={current} pageSize={pageSize} />
  );
};

interface Filtro {
  Nombre: string,
  FechaIni: Moment,
  FechaFin: Moment
}

const TablaUsuarios = (prop) => {
  const [filtro, setfiltro] = useState<Filtro>();
  const [data, setData] = useState({ data: [], totalRecords: 0 });
  const [current, setCurrent] = useState(1);
  const columns = [
    {
      title: 'Apellidos y Nombres',
      dataIndex: 'nombres',
      render: (val, row, index) => {
        return `${row.apellidos} ${row.nombres}`;
      }
    },
    {
      title: 'Estado',
      dataIndex: 'restriccionAcceso',
      render: (text, row, index) => {
        if (row.restriccionAcceso) return <Text style={{ color: '#1890ff' }}>Restricción de Acceso</Text>;
        else return <></>;
      }
    },
    {
      title: 'Acciones',
      dataIndex: 'operation',
      render: (text, row, index) =>
        data.data.length >= 1 ? (
          <Popconfirm title='Que desea hacer?' cancelText='Permitir Acceso' okText='Editar'
                      onCancel={() => permitirAcceso(row)}
                      onConfirm={() => prop[0](row)}>
            <a onClick={(e) => e.preventDefault()} href='#'>Opción</a>
          </Popconfirm>
        ) : null
    }
  ];

  const permitirAcceso = async (val) => {
    message.warning('Habilitando acceso...', 5);
    const response = await seguridadProvider.permitirAcceso(val);
  };

  const obtenerUsuarios = async () => {
    const paginacion = {
      Page: filtro !== undefined && filtro.Nombre !== '' ? 0 : current - 1,
      PageSize: pageSize,
      Filter: {
        nombre: filtro !== undefined ? filtro.Nombre : null
      }
    };
    const res: any = await seguridadProvider.obtenerUsuarios(paginacion);
    if (res.data) {
      setData(res);
    }
  };

  useEffect(() => {
    obtenerUsuarios();
  }, [filtro]);

  useEffect(() => {
    obtenerUsuarios();
  }, [current]);

  return (
    <>
      <Row justify={'end'}>
        <Col>
          <Search placeholder='Buscar...'
                  onSearch={(value) => setfiltro({ Nombre: value, FechaIni: undefined, FechaFin: undefined })}
                  allowClear={true} style={{ width: 300 }} />
        </Col>
      </Row>
      <Divider />
      <Table locale={{ emptyText: 'No existen registros' }} pagination={false} columns={columns} dataSource={data.data}
             bordered />
      <Row justify={'center'}>
        <Col>
          <PaginacionPersonalizada total={data.totalRecords} current={current} onChange={setCurrent} />
        </Col>
      </Row>
    </>
  );
};

export default TablaUsuarios;
